import { motion } from "framer-motion";
import { ReactNode } from "react";

interface RevealProps {
    children: ReactNode;
    delay?: number;
    duration?: number;
    width?: "auto" | "full";
    className?: string;
    trigger?: "onView" | "onLoad";
}

export const Reveal = ({
    children,
    delay = 0,
    duration = 1.2,
    width = "auto",
    className = "",
    trigger = "onView"
}: RevealProps) => {
    const variants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
    };

    return (
        <div className={`relative ${width === "full" ? "w-full" : "w-fit"} ${className}`}>
            <motion.div
                variants={variants}
                initial="hidden"
                animate={trigger === "onLoad" ? "visible" : undefined}
                whileInView={trigger === "onView" ? "visible" : undefined}
                viewport={{ once: true, margin: "-5%" }}
                transition={{ duration, delay, ease: [0.23, 1, 0.32, 1] }}
                className={className.includes("h-full") ? "h-full" : ""}
            >
                {children}
            </motion.div>
        </div>
    );
};

export const ImageReveal = ({
    src,
    alt,
    aspect = "aspect-video",
    className = "",
    delay = 0
}: {
    src: string;
    alt: string;
    aspect?: string;
    className?: string;
    delay?: number;
}) => {
    return (
        <div className={`${aspect} bg-secondary/10 rounded-2xl overflow-hidden relative ${className}`}>
            <motion.img
                initial={{ y: "100%" }}
                whileInView={{ y: 0 }}
                viewport={{ once: true, margin: "10%" }}
                transition={{ duration: 1.8, delay, ease: [0.23, 1, 0.32, 1] }}
                src={src}
                alt={alt}
                className="w-full h-full object-cover"
            />
        </div>
    );
};
